/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import rootReducer from './reducer';
import appReducer from '../containers/App/reducer';
import registrationReducer, { key as regKey } from '../containers/Authentification/Registration/reducer';
import HomeReducer, { key as HomeReducerKey } from '../containers/Home/reducer';
import ProductionUpdateSteps, { key as ProductionUpdateStepsKey } from '../containers/ProductionUpdateSteps/reducer';
import Company, { key as CompanyReducerKey } from '../containers/Company/reducer';
import Artist, { key as ArtistKey } from '../containers/Artist/reducer';
import AgencyByCountryReducer, { key as AgencyByCountryKey } from '../containers/ManagersByCountry/reducer';
import AgencyReducer, { key as AgencyKey } from '../containers/Managers/reducer';
import festivalReducer from '../containers/Festival/reducer';
import videosReducer from '../containers/Videos/reducer';
import festivalsReducer from '../containers/Festivals/reducer';
import AccountSettingsReducer, {
  key as AccountSettingsKey,
} from '../containers/UserContainers/AccountSettingsContainer/reducer';
import NotificationReducer from '../containers/Notifications/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const dynamicReducer = combineReducers({
    global: rootReducer,
    App: appReducer,
    Festival: festivalReducer,
    Register: registrationReducer,
    AccountSettings: AccountSettingsReducer,
    Notifications: NotificationReducer,
    Videos: videosReducer,
    Festivals: festivalsReducer,
    ...injectedReducers,
  });

  return dynamicReducer;
}

export const reducersList = [
  { key: regKey, reducer: registrationReducer },
  { key: HomeReducerKey, reducer: HomeReducer },
  { key: ProductionUpdateStepsKey, reducer: ProductionUpdateSteps },
  { key: AccountSettingsKey, reducer: AccountSettingsReducer },
  { key: CompanyReducerKey, reducer: Company },
  { key: ArtistKey, reducer: Artist },
  { key: AgencyByCountryKey, reducer: AgencyByCountryReducer },
  { key: AgencyKey, reducer: AgencyReducer },
];
